import { COUNTY_FIPS_TO_NAME } from './countyFipsMapping';

/** 5-digit FIPS: state (06) + county (3) for California */
export function countyNameToCaCountyPrefix(countyName: string): string | null {
  const base = countyName.replace(/\s+county$/i, '').trim().toUpperCase();
  for (const [fips3, name] of Object.entries(COUNTY_FIPS_TO_NAME)) {
    if (name === base) return `06${fips3}`;
  }
  return null;
}

export const WALKABILITY_CLASS_ORDER = [
  'Highly walkable',
  'Above average walkability',
  'Moderate walkability',
  'Below average walkability',
  'Least walkable'
] as const;

/**
 * Buckets use nat_walk_ind_percentile (0–100, higher = more walkable), aligned with CA tract distribution.
 */
export function walkabilityClassFromPercentile(pct: number | null | undefined): string | null {
  if (pct == null || Number.isNaN(Number(pct))) return null;
  const p = Number(pct);
  if (p >= 80) return 'Highly walkable';
  if (p >= 60) return 'Above average walkability';
  if (p >= 40) return 'Moderate walkability';
  if (p >= 20) return 'Below average walkability';
  return 'Least walkable';
}

export function normalizeTractGeofips(raw: string | number | null | undefined): string {
  if (raw == null) return '';
  const s = String(raw).replace(/\D/g, '');
  if (!s) return '';
  return s.padStart(11, '0').slice(0, 11);
}
